import React, { useCallback, useEffect, useState } from 'react';

import {
  Box,
  Button,
  Grid,
  Link,
  Typography,
  useMediaQuery,
  useTheme,
} from '@material-ui/core';

import ComplaintImg from '../../../../assets/img/denuncia.svg';
import WhatsappSrc from '../../../../assets/img/whatsapp.svg';
// import WhatsappSrc from '../../../../assets/img/whatsapp.png';
import Dropzone from '../../../../components/Dropzone/Dropzone.component';
import SharedDialog from '../../../../components/SharedDialog/SharedDialog.component';
import { appConfig } from '../../../../config/app';
import { IncidentsDocumentsTypes } from '../../../../constants/incidents.constant';
import { useSinisterDataContext } from '../../../../context/sinister/sinister.provider';

const InsideInspectionElement = ({ onAction }: any) => (
  <>
    {/* <img src={ComplaintImg} alt="denuncia" /> */}
    <Box my={3}>
      <Button variant="contained" color="primary" onClick={onAction}>
        Foto de la denuncia
      </Button>
    </Box>
  </>
);

const Complaint = () => {
  const {
    success,
    errors,
    nextStep,
    sinister_body,
    image_preview,
    updloadPhotos,
  } = useSinisterDataContext();
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down('sm'));

  const [complaintImage, setComplaintImage] = useState('');
  const [complaintImage2, setComplaintImage2] = useState('');
  const [preview, setPreview] = useState(
    image_preview.find(
      (prev: any) =>
        prev.type === sinister_body.incident_type &&
        prev.photo_type === IncidentsDocumentsTypes.POLICE_COMPLAINT &&
        prev.side === 'front'
    )
  );

  const [open, setOpen] = useState(false);
  const [hasTwo, setHasTwo] = useState(!!preview?.['photo[1]']);

  const handlingNext = (skipped: boolean = false) => {
    if (!skipped) {
      const { incident_type, vehicle_id } = sinister_body;

      updloadPhotos({
        type: incident_type,
        vehicle_id: vehicle_id,
        photo_type: IncidentsDocumentsTypes.POLICE_COMPLAINT,
        side: 'front',
        'photo[0]': complaintImage,
        'photo[1]': complaintImage2 ? complaintImage2 : undefined,
      });
    } else {
      nextStep();
    }
  };

  const continueToNext = useCallback(() => {
    setPreview(
      image_preview.find(
        (prev: any) =>
          prev.type === sinister_body.incident_type &&
          prev.photo_type === IncidentsDocumentsTypes.POLICE_COMPLAINT &&
          prev.side === 'front'
      )
    );
    nextStep();
  }, [image_preview, nextStep, sinister_body.incident_type]);

  useEffect(() => {
    if (success.photo) {
      continueToNext();
    }
  }, [success, continueToNext]);

  useEffect(() => {
    if (errors.photo) {
      setOpen(true);
    }
  }, [errors]);

  return (
    <>
      <SharedDialog
        open={open}
        onClose={() => setOpen(false)}
        content={
          <Box>
            <Box mb={2}>
              <Typography variant="h6">
                ¡Lo sentimos! no pudimos procesar correctamente tus fotos
              </Typography>
              <Typography variant="body2">
                Podés reintentar en unos instantes o comunicarte con nosotros
                por Whatsapp para cargar tu denuncia.
              </Typography>
            </Box>
          </Box>
        }
        actions={
          <Grid container justify="flex-end">
            <Grid item xs={12} sm={6}>
              <Box m={2} display="flex" alignItems="center">
                <Link
                  href={appConfig?.WHATSAPP_LINK}
                  rel="noopener"
                  target="_blank"
                >
                  <Button variant="outlined" fullWidth color="secondary">
                    <img
                      src={WhatsappSrc}
                      alt="Whatsapp"
                      style={{ marginLeft: '15px' }}
                    />
                    <Typography display="inline">
                      Comunicarme vía Whatsapp
                    </Typography>
                  </Button>
                </Link>
              </Box>
            </Grid>
            <Grid item xs={12} sm={6}>
              <Box m={2}>
                <Button
                  variant="contained"
                  color="primary"
                  fullWidth
                  onClick={() => setOpen(false)}
                >
                  Entendido
                </Button>
              </Box>
            </Grid>
          </Grid>
        }
      ></SharedDialog>

      <Grid container>
        <Grid item xs={12}>
          <Box my={2}>
            <Typography variant="h6" color="textPrimary">
              ¡Revisa que la foto se vea bien!
            </Typography>
          </Box>
          <Box mb={3}>
            {!matches && (
              <Typography variant="body1">
                Que no esté borrosa, cortada, y ni oscura.
              </Typography>
            )}
          </Box>
        </Grid>
        <Grid item xs={12} md={12}>
          <Grid container justify="center" alignItems="center">
            <Grid item xs={hasTwo ? 6 : 12}>
              <Box m={2}>
                <Dropzone
                  onChange={(file: string) => setComplaintImage(file)}
                  onNext={handlingNext}
                  preview={preview?.['photo[0]']}
                  hideContinueBtn={hasTwo}
                  optional
                  getFile
                >
                  <InsideInspectionElement />
                </Dropzone>
              </Box>
            </Grid>

            {hasTwo ? (
              <>
                <Grid item xs={hasTwo ? 6 : 12}>
                  <Box m={2}>
                    <Dropzone
                      onChange={(file: string) => setComplaintImage2(file)}
                      onNext={handlingNext}
                      preview={preview?.['photo[1]']}
                      hideContinueBtn={true}
                      optional
                      getFile
                    >
                      <InsideInspectionElement />
                    </Dropzone>
                  </Box>
                </Grid>
                <Box m={5} textAlign="center">
                  <Button
                    variant="contained"
                    color="primary"
                    onClick={() => handlingNext()}
                    fullWidth
                  >
                    Continuar
                  </Button>
                </Box>
              </>
            ) : null}
          </Grid>
        </Grid>
        <Grid container justify="center" alignItems="center">
          <Grid item xs={6}>
            <Box textAlign="center">
              <Button
                variant="outlined"
                color="secondary"
                onClick={() => setHasTwo(!hasTwo)}
                disabled={hasTwo}
              >
                + Agregar otra fotografía
              </Button>
            </Box>
          </Grid>
        </Grid>
      </Grid>
    </>
  );
};

export default Complaint;
